export default ".btn_primary {\n  padding: 8px 20px;\n  font-size: 18px;\n}"